/**
 * Resolves a localized name record to a display string, preferring English.
 * Falls back to the first available language, then to 'Unnamed'.
 */
export const getLocalizedName = (
    name: Record<string, string> | undefined
): string => (name && (name['en'] || Object.values(name)[0])) || 'Unnamed';
